type CardKickerProps = {
  /** Optional additional styling for the container*/
  className?: string;
  /** The text to display as kicker. */
  text?: string;
};

/**
 * CardKicker component that renders a kicker text.
 * It is used to display additional information or context for the card.
 */
const CardKicker = ({
  className,
  text,
}: CardKickerProps): React.ReactElement => {
  return (
    <div data-testid="card-kicker-component" className={className}>
      {text}
    </div>
  );
};

export default CardKicker;
